import { Tabs, TabsProps } from "antd";
import PageHeading from "components/PageHeading.component";
import SecurityProfileCard from "components/profile/SecurityProfile.component";
import UserProfileCard, {
  getPrimaryUserType,
} from "components/profile/UserProfile.component";
import { useAuth } from "context/AuthContextProvider";
import InstructorRoleToggleCard from "pages/instructors/InstructorRoleToggleCard";
import { Flex } from "antd";
import { translate } from "shared/languages";
import { UserType } from "shared/types/enum";
import { isManager } from "shared/utils/role";

const UserProfilePage = () => {
  const { state } = useAuth();
  const user = state.user;
  // This is always a self-view (state.user, never someone else's account),
  // so there's no route-sharing ambiguity to resolve — pass the account's
  // real highest-privilege role directly instead of a hardcoded guess.
  // Hardcoding Admin here previously meant a Manager (whose roles always
  // additionally include "admin") saw their own "Peran" badge read "Admin"
  // instead of "Manager".
  const thisUserType = user ? getPrimaryUserType(user.roles) ?? UserType.Admin : UserType.Admin;

  const items: TabsProps["items"] = [
    {
      key: "1",
      label: translate("tabs.my_profile"),
      children: user && (
        <Flex vertical gap={16}>
          <UserProfileCard user={user} thisUserType={thisUserType} />
          {/* A Manager can switch their own instructor hat here too. */}
          {isManager(user.roles) && <InstructorRoleToggleCard user={user} />}
        </Flex>
      ),
    },
    {
      key: "2",
      label: translate("tabs.security"),
      children: user && <SecurityProfileCard user={user} />,
    },
  ];

  return (
    <>
      <PageHeading title={translate("title.account_settings")} />
      <Tabs defaultActiveKey="1" size="small" items={items} />
    </>
  );
};
export default UserProfilePage;
